import React, { useState, useCallback, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import { FiSend } from "react-icons/fi";
import { SiKakaotalk, SiMaildotru } from "react-icons/si";
import { BiClipboard } from "react-icons/bi";
import styles from "./ShareButtons.module.css";
import platform from "platform";

const ShareButtons = ({ open, onClose, url, title }) => {
  const defaultState = {
    isMobile: false,
  };
  const [state, setState] = useState(defaultState);
  const isMobile = useCallback(() => {
    const os = platform.os.family || "";
    return /Android|iOS/.test(os);
  }, []);
  useLayoutEffect(() => {
    setState((s) => ({ ...s, isMobile: isMobile() }));
  }, []);

  const handleFacebook = () => {
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url
    )}`;
    window.open(shareUrl, "_blank", "width=600,height=400");
  };

  const handleTwitter = () => {
    const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      url
    )}&text=${encodeURIComponent(title)}`;
    window.open(shareUrl, "_blank", "width=600,height=400");
  };

  const handleKakao = () => {
    window.Kakao.Link.sendDefault({
      objectType: "feed",
      content: {
        title,
        description: title,
        imageUrl: url + "/favicon.ico",
        link: { mobileWebUrl: url, webUrl: url },
      },
      buttons: [
        { title: "웹으로 보기", link: { mobileWebUrl: url, webUrl: url } },
      ],
    });
  };

  const copyClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
  };

  const handleInstagram = async () => {
    await copyClipboard();
    alert(
      `🔗링크가 클립보드에 복사되었습니다.\nInstagram 앱에 붙여넣어 공유하세요.`
    );
  };

  const handleSMS = () => {
    window.location.href = `sms:?body=${encodeURIComponent(
      title + `\n` + url
    )}`;
  };

  const handleClipboard = async () => {
    await copyClipboard();
    alert(
      `🔗링크가 클립보드에 복사되었습니다.\n원하는 곳에 붙여넣어 공유하세요.`
    );
  };

  const handleMailtoShare = () => {
    const mailtoUrl =
      `mailto:?subject=${encodeURIComponent(title)}` +
      `&body=${encodeURIComponent(url)}`;
    const mailWindow = window.open(mailtoUrl, "_blank", "width=600,height=400");
    // 창이 제대로 열렸으면, 2초 뒤 닫기
    if (mailWindow) {
      setTimeout(() => {
        // 아직 열려 있으면 닫기
        if (!mailWindow.closed) mailWindow.close();
      }, 2000);
    }
  };

  if (!open) return null;
  return createPortal(
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button className={styles.closeBtn} onClick={onClose}>
          ×
        </button>
        <h3 className={styles.title}>공유하기</h3>
        <div className={styles.buttons}>
          <button className={styles.button} onClick={handleKakao}>
            <SiKakaotalk className={styles.icon} /> KakaoTalk
          </button>
          {state.isMobile ? (
            <button className={styles.button} onClick={handleSMS}>
              <FiSend className={styles.icon} /> Message
            </button>
          ) : (
            <button className={styles.button} onClick={handleMailtoShare}>
              <SiMaildotru className={styles.icon} /> Email
            </button>
          )}
          <button className={styles.button} onClick={handleInstagram}>
            <FaInstagram className={styles.icon} /> Instagram
          </button>
          <button className={styles.button} onClick={handleFacebook}>
            <FaFacebookF className={styles.icon} /> Facebook
          </button>
          <button className={styles.button} onClick={handleTwitter}>
            <FaTwitter className={styles.icon} /> Twitter
          </button>
          <button className={styles.button} onClick={handleClipboard}>
            <BiClipboard className={styles.icon} /> Clipboard
          </button>
          {!state.isMobile && (
            <button className={styles.button} disabled style={{ opacity: 0 }} />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ShareButtons;
